export default "__VITE_ASSET__35b505f2__"